<button (mouseleave)="isHovering = false" (mouseenter)="isHovering = true"
    class="icon-btn{{size ? ' -size-'+size : ''}}" (click)="handleButtonClick($event)" [title]="title || ''"
    [ngClass]="{'is-disabled': disabled, 'is-hovering': isHovering, 'is-active': isActive && !disabled, '-inverted': inverted, '-emphasis': emphasis}"
    [disabled]="disabled" [type]="type">

    <span class="icon-btn__bd">
        <span class="icon-btn__icon" *ngIf="icon && (!isHovering && iconHover || !iconHover)">
            <shared-icon class="icon-btn__icon-obj" [icon]="icon"></shared-icon>
        </span>
        <span class="icon-btn__icon -for-hover" *ngIf="iconHover && isHovering">
            <shared-icon class="icon-btn__icon-obj" [icon]="iconHover"></shared-icon>
        </span>
        <span class="icon-btn__label" #content [hidden]="!hasContent">
            <ng-content></ng-content>
        </span>
    </span>
</button>